'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exportAsCss = exportAsCss;
exports.mergeCss = mergeCss;

var _aphrodite = require('aphrodite');

var _collections = require('./collections');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * 
 * Converts a raw aphrodite styles object into one that can be injected
 * into a React component's `className` attribute.
 */
function exportAsCss(stylesheet) {
    var cssStyles = {};
    Object.keys(stylesheet).map(function (key) {
        cssStyles[key] = (0, _aphrodite.css)(stylesheet[key]);
        return key;
    });
    return cssStyles;
}

/**
 * 
 * Merges two Stylesheet objects into one, using
 * Aphrodite's `css` function to perform the merge of
 * individual classes.
 * @return object: css object consisting of the resulting generated styles
 */
function mergeCss() {
    for (var _len = arguments.length, stylesheets = Array(_len), _key = 0; _key < _len; _key++) {
        stylesheets[_key] = arguments[_key];
    }

    var merged = {};
    // Collect all the unique keys for each stylesheet
    var keys = [];
    stylesheets.forEach(function (stylesheet) {
        keys = keys.concat(Object.keys(stylesheet));
    });
    keys = (0, _collections.uniq)(keys);
    // Merge the css values for all stylesheets
    keys.forEach(function (key) {
        var cssModules = stylesheets.map(function (stylesheet) {
            return stylesheet[key];
        });
        merged[key] = _aphrodite.css.apply(undefined, _toConsumableArray(cssModules));
    });
    return merged;
}